/**
 * Проверяет, не является ли переданный аргумент null или undefined и исключает типы null и undefined из типа аргумента
 *
 * @param value Значение, которое нужно проверить и исключить из него типы
 * @returns Возвращает true, если переданный аргумент не является null или undefined иначе false
 */
export var isNonNullable = function (value) {
    return value !== null && value !== undefined;
};
/**
 * Merges two or more refs into one.
 *
 * @param refs Array of refs.
 * @returns A single ref composing all the refs passed.
 *
 * @example
 * const SomeComponent = forwardRef((props, ref) => {
 *  const localRef = useRef();
 *
 *  return <div ref={mergeRefs([localRef, ref])} />;
 * });
 */
export function mergeRefs(refs) {
    return function (value) {
        refs.forEach(function (ref) {
            if (typeof ref === 'function') {
                return ref(value);
            }
            else if (isNonNullable(ref)) {
                return (ref.current = value);
            }
        });
    };
}
/**
 * Character for center alignment.
 *
 * @see https://www.fileformat.info/info/unicode/char/200b/index.htm
 */
export var ZERO_WIDTH_SPACE = String.fromCharCode(0x200b);
/**
 * Checks if the node is a Document.
 *
 * Suitable for use in same-origin iframes.
 *
 * @param {Node} node - The node to check.
 * @returns {boolean} - True if the node is a Document, otherwise false.
 */
export function isDocument(node) {
    return node.nodeType === Node.DOCUMENT_NODE;
}
/**
 * Checks if the node is a ShadowRoot.
 *
 * Suitable for use in same-origin iframes.
 *
 * @param {Node} node - The node to check.
 * @returns {boolean} - True if the node is a ShadowRoot, otherwise false.
 */
export function isShadowRoot(node) {
    return node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && 'adoptedStyleSheets' in node;
}
